import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';



export default function Step5() {

  return (
    <>
        <Grid container spacing={3}>
            <Grid item  xs={12} sm={6}>
                <TextField id="independentwitness1" fullWidth  label="Witness 1" />
            </Grid>

            <Grid item  xs={12} sm={6}>
            <TextField id="independentwitnessphone1" fullWidth label="Phone" />
        </Grid>
        </Grid>

        <Grid container spacing={3}>
            <Grid item  xs={12} sm={12}>
                <TextField id="independentwitnessaddress1" fullWidth  label="Address" />
            </Grid>
            </Grid>




        <Grid container spacing={3}>
            <Grid item  xs={12} sm={6}>
                <TextField id="independentwitness2" fullWidth  label="Witness 2" />
            </Grid>

            <Grid item  xs={12} sm={6}>
            <TextField id="independentwitnessphone2" fullWidth label="Phone" />
        </Grid>
        </Grid>

        <Grid container spacing={3}>
            <Grid item  xs={12} sm={12}>
                <TextField id="companyindependentwitnessaddress2" fullWidth  label="Address" />
            </Grid>
            </Grid>





        <Grid container spacing={3}>
            <Grid item  xs={12} sm={6}>
                <TextField id="independentwitness3" fullWidth  label="Witness 3" />
            </Grid>

            <Grid item  xs={12} sm={6}>
            <TextField id="independentwitnessphone3" fullWidth label="Phone" />
        </Grid>
        </Grid>

        <Grid container spacing={3}>
            <Grid item  xs={12} sm={12}>
                <TextField id="independentwitnessaddress3" fullWidth  label="Address" />
            </Grid>
            </Grid>

    

</>
    
  );

}
